export const selectReducer = (state) => state.w2pSingleContentManagement;

export const selectW2PSingleContent = (state) =>
  selectReducer(state)
    ? selectReducer(state).get('w2pSingleContent')
    : undefined;
